/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TarifCommandDto } from './TarifCommandDto';
import {
    TarifCommandDtoFromJSON,
    TarifCommandDtoFromJSONTyped,
    TarifCommandDtoToJSON,
    TarifCommandDtoToJSONTyped,
} from './TarifCommandDto';

/**
 * 
 * @export
 * @interface CreateCommissionGarantieCommand
 */
export interface CreateCommissionGarantieCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateCommissionGarantieCommand
     */
    natureRemunerationId: string;
    /**
     * 
     * @type {TarifCommandDto}
     * @memberof CreateCommissionGarantieCommand
     */
    tarif: TarifCommandDto;
    /**
     * 
     * @type {string}
     * @memberof CreateCommissionGarantieCommand
     */
    beneficiairePersonneId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCommissionGarantieCommand
     */
    compteBancaireId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCommissionGarantieCommand
     */
    garantieTunnelId: string;
}

/**
 * Check if a given object implements the CreateCommissionGarantieCommand interface.
 */
export function instanceOfCreateCommissionGarantieCommand(value: object): value is CreateCommissionGarantieCommand {
    if (!('natureRemunerationId' in value) || value['natureRemunerationId'] === undefined) return false;
    if (!('tarif' in value) || value['tarif'] === undefined) return false;
    if (!('garantieTunnelId' in value) || value['garantieTunnelId'] === undefined) return false;
    return true;
}

export function CreateCommissionGarantieCommandFromJSON(json: any): CreateCommissionGarantieCommand {
    return CreateCommissionGarantieCommandFromJSONTyped(json, false);
}

export function CreateCommissionGarantieCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCommissionGarantieCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'natureRemunerationId': json['natureRemunerationId'],
        'tarif': TarifCommandDtoFromJSON(json['tarif']),
        'beneficiairePersonneId': json['beneficiairePersonneId'] == null ? undefined : json['beneficiairePersonneId'],
        'compteBancaireId': json['compteBancaireId'] == null ? undefined : json['compteBancaireId'],
        'garantieTunnelId': json['garantieTunnelId'],
    };
}

export function CreateCommissionGarantieCommandToJSON(json: any): CreateCommissionGarantieCommand {
    return CreateCommissionGarantieCommandToJSONTyped(json, false);
}

export function CreateCommissionGarantieCommandToJSONTyped(value?: CreateCommissionGarantieCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'natureRemunerationId': value['natureRemunerationId'],
        'tarif': TarifCommandDtoToJSON(value['tarif']),
        'beneficiairePersonneId': value['beneficiairePersonneId'],
        'compteBancaireId': value['compteBancaireId'],
        'garantieTunnelId': value['garantieTunnelId'],
    };
}

